"use strict";

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "@emotion/core", "recompose/onlyUpdateForKeys", "./helpers"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("@emotion/core"), require("recompose/onlyUpdateForKeys"), require("./helpers"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.core, global.onlyUpdateForKeys, global.helpers);
    global.undefined = mod.exports;
  }
})(void 0, function (exports, _react, _core, _onlyUpdateForKeys, _helpers) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _templateObject2() {
    var data = _taggedTemplateLiteral(["\n  0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)}\n  100% {transform: rotateX(360deg) rotateY(180deg) rotateZ(360deg)}\n"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    var data = _taggedTemplateLiteral(["\n  0% {transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)}\n  100% {transform: rotateX(180deg) rotateY(360deg) rotateZ(360deg)}\n"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  var right = (0, _core.keyframes)(_templateObject());
  var left = (0, _core.keyframes)(_templateObject2());

  var Loader = function (_React$Component) {
    _inherits(Loader, _React$Component);

    function Loader() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Loader);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Loader)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "style", function (i) {
        var _this$props = _this.props,
            size = _this$props.size,
            sizeUnit = _this$props.sizeUnit,
            color = _this$props.color;
        return (0, _core.css)("{position:absolute;top:0;left:0;width:", "".concat(size).concat(sizeUnit), ";height:", "".concat(size).concat(sizeUnit), ";border:", "".concat(size / 10).concat(sizeUnit), " solid ", color, ";opacity:0.4;border-radius:100%;animation-fill-mode:forwards;perspective:800px;animation:", i === 1 ? right : left, " 2s 0s infinite linear;}label:style;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
      });

      _defineProperty(_assertThisInitialized(_this), "wrapper", function () {
        var _this$props2 = _this.props,
            size = _this$props2.size,
            sizeUnit = _this$props2.sizeUnit;
        var wrapper = (0, _core.css)("{width:", "".concat(size).concat(sizeUnit), ";height:", "".concat(size).concat(sizeUnit), ";position:relative;}label:wrapper;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
        return _this.props.css ? (0, _core.css)(wrapper, ";", _this.props.css, "label:wrapper;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")) : wrapper;
      });

      return _this;
    }

    _createClass(Loader, [{
      key: "render",
      value: function render() {
        var loading = this.props.loading;
        return loading ? (0, _core.jsx)("div", {
          css: this.wrapper()
        }, (0, _core.jsx)("div", {
          css: this.style(1)
        }), (0, _core.jsx)("div", {
          css: this.style(2)
        })) : null;
      }
    }]);

    return Loader;
  }(_react2["default"].Component);

  Loader.propTypes = _helpers.sizeProps;
  Loader.defaultProps = (0, _helpers.sizeDefaults)(60);
  var Component = (0, _onlyUpdateForKeys2["default"])(_helpers.sizeKeys)(Loader);
  Component.defaultProps = Loader.defaultProps;
  exports["default"] = Component;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-spinners/RingLoader.js
// module id = 913
// module chunks = 2